import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useInfiniteHits } from 'react-instantsearch';

/**
 * Wrapper for the legacy connectInfiniteHits HOC from react-instantsearch-dom v6.
 * This provides the same API but uses the v7 react-instantsearch hook internally.
 *
 * CRITICAL: The hookParams must be memoized to prevent infinite re-render loops.
 * Creating a new object on every render causes useInfiniteHits to see changed
 * dependencies, triggering cascading re-renders.
 *
 * @param {Function} Component - A component that receives infinite hits data as props
 * @returns {React.Component} - A wrapped component connected to InstantSearch infinite hits
 */
export const connectInfiniteHits = Component => {
  const ConnectedComponent = props => {
    const $ = _c(8);
    const {
      escapeHTML,
      transformItems,
      cache,
      showPrevious
    } = props;
    let t0;
    if ($[0] !== cache || $[1] !== escapeHTML || $[2] !== showPrevious || $[3] !== transformItems) {
      t0 = {
        escapeHTML,
        transformItems,
        cache,
        showPrevious
      };
      $[0] = cache;
      $[1] = escapeHTML;
      $[2] = showPrevious;
      $[3] = transformItems;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    const hookParams = t0;
    const data = useInfiniteHits(hookParams);
    let t1;
    if ($[5] !== data || $[6] !== props) {
      t1 = <Component {...props} {...data} />;
      $[5] = data;
      $[6] = props;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  };
  ConnectedComponent.displayName = `connectInfiniteHits(${Component.displayName || Component.name || 'Component'})`;
  return ConnectedComponent;
};
export default connectInfiniteHits;